import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import _ from 'lodash';
import config from '../config';
import { AuthContext } from '../context/auth';
import fetcher from '../context/fetcher';

// Валидация формы
const validationSchema = Yup.object({
    productId: Yup.string()
        .required('Required')
        .matches(/^[a-zA-Z0-9._]+$/, 'Invalid productId'),
    title: Yup.string().required('Required'),
    price: Yup.number().required('Required').min(0, 'Price must be positive'),
    description: Yup.string(),
});

export default class Product extends Component {
    static contextType = AuthContext;

    constructor(props, context) {
        super(props);
        this.authContext = context;
        const { id } = this.props.match.params;
        this.state = {
            id,
            obj: id === 'new' ? {
                _id: 'new',
                productId: '',
                title: '',
                description: '',
                price: 0,
            } : null,
            redirect: null,
            error: null,
        };
        this.init = this.init.bind(this);
        this.save = this.save.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        if (id !== 'new') {
            this.init(id);
        }
    }

    async init(id) {
        if (id !== 'new') {
            try {
                let responseProducts = await fetcher(`${config.API()}collection/products`);
                let products = await responseProducts.json();
                let obj = _.find(products, (x) => x._id === id);
                if (obj) {
                    this.setState({ obj });
                } else {
                    this.setState({ error: 'Product not found' });
                }
            } catch (err) {
                this.setState({ error: 'Failed to load product' });
            }
        }
    }

    async save(values) {
        try {
            const body = JSON.stringify(values);
            await fetcher(`${config.API()}collection/products/save`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body,
            });
            this.setState({ redirect: '/products' });
        } catch (err) {
            this.setState({ error: 'Failed to save product' });
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }
        return (
            <div>
                {this.state.error && (
                    <div className="alert alert-danger">{this.state.error}</div>
                )}
                {this.state.obj && (
                    <Formik
                        initialValues={this.state.obj}
                        validationSchema={validationSchema}
                        onSubmit={this.save}
                    >
                        {({
                              values,
                              errors,
                              touched,
                              handleSubmit,
                              handleChange,
                              setFieldValue,
                              isSubmitting,
                              myHandleChange = (evt) => {
                                  if (evt.target.type === 'number' && evt.target.value === '') {
                                      evt.target.value = 0;
                                  }
                                  handleChange(evt);
                              },
                          }) => (
                            <div className="card shadow w-100">
                                <div className="card-header py-3">
                                    <h2 className="m-0 font-weight-bold">
                                        Product <span className="text-primary">{values.productId}</span>
                                    </h2>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        {values._id !== 'new' && (
                                            <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">Id</label>
                                                <div className="col-sm-9">
                                                    {values._id}
                                                    <input
                                                        type="hidden"
                                                        name="_id"
                                                        onChange={myHandleChange}
                                                        value={values._id}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">
                                                ProductId
                                                <span
                                                    className="fas fa-fw fa-info-circle text-primary ml-1"
                                                    title="Google Play, App Store: Уникальный идентификатор продукта, например, com.example.product1. Используется для идентификации In-App Product."
                                                ></span>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    className={`form-control ${errors.productId && touched.productId ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    name="productId"
                                                    onChange={myHandleChange}
                                                    value={values.productId}
                                                />
                                                {errors.productId && touched.productId && (
                                                    <div className="invalid-feedback">{errors.productId}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">
                                                Title
                                                <span
                                                    className="fas fa-fw fa-info-circle text-primary ml-1"
                                                    title="Google Play, App Store: Публичное название продукта, отображаемое пользователям в магазине."
                                                ></span>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    className={`form-control ${errors.title && touched.title ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    name="title"
                                                    onChange={myHandleChange}
                                                    value={values.title}
                                                />
                                                {errors.title && touched.title && (
                                                    <div className="invalid-feedback">{errors.title}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">
                                                Description
                                                <span
                                                    className="fas fa-fw fa-info-circle text-primary ml-1"
                                                    title="Google Play, App Store: Описание продукта. В Google Play отображается в магазине, в App Store используется для заметок или локализаций."
                                                ></span>
                                            </label>
                                            <div className="col-sm-9">
                                                <textarea
                                                    className="form-control"
                                                    name="description"
                                                    onChange={myHandleChange}
                                                    value={values.description}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">
                                                Price (USD)
                                                <span
                                                    className="fas fa-fw fa-info-circle text-primary ml-1"
                                                    title="Google Play, App Store: Базовая цена в USD. В Google Play конвертируется в местные валюты."
                                                ></span>
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    className={`form-control ${errors.price && touched.price ? 'is-invalid' : ''}`}
                                                    type="number"
                                                    name="price"
                                                    step="0.01"
                                                    onChange={myHandleChange}
                                                    value={values.price}
                                                />
                                                {errors.price && touched.price && (
                                                    <div className="invalid-feedback">{errors.price}</div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-sm-9 offset-sm-3">
                                                <button
                                                    type="submit"
                                                    className="btn btn-icon btn-success ml-1"
                                                    disabled={isSubmitting}
                                                >
                                                    <span className="fas fa-fw fa-save"></span>Save
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}
                    </Formik>
                )}
            </div>
        );
    }
}